import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { LoadingContainer } from "go-core/components/Loading";
import { OrganizationProductPerCategoryApi, UserRole } from "../../../../../../services/Api/types";
import OrganizationProductsCardItem from "./OrganizationProductsCardItem";

interface Props {
	products: OrganizationProductPerCategoryApi[];
	loading: boolean;
	currency: string;
	url: string;
	areAllowed: (contexts: Record<string, UserRole[]>) => boolean;
}

const OrganizationProductsCard = ({ products, loading, currency, url, areAllowed }: Props) => {
	const { t } = useTranslation("admin");
	const [showMore, setShowMore] = useState(false);
	const DEFAULT_PRODUCTS_TO_SHOW = 3;

	return (
		<Card className="organization-products-card">
			<Card.Body>
				<h5 className={"d-flex justify-content-between align-items-center"}>
					{t("enums.organization.card_type.PRODUCTS")}
				</h5>
				{loading ? (
					<LoadingContainer />
				) : (
					<div className="d-flex flex-column">
						{(showMore ? products : products.filter((_, index) => index < DEFAULT_PRODUCTS_TO_SHOW)).map(
							(product) => (
								<React.Fragment key={product.id}>
									<OrganizationProductsCardItem product={product} currency={currency} />
									<hr />
								</React.Fragment>
							)
						)}
					</div>
				)}
				{products.length > DEFAULT_PRODUCTS_TO_SHOW && (
					<Button className="w-100" variant="add" onClick={() => setShowMore((prevState) => !prevState)}>
						{showMore ? t("lib:common.action.show_less") : t("lib:common.action.show_more")}
					</Button>
				)}
			</Card.Body>
		</Card>
	);
};

export default OrganizationProductsCard;
